import PropTypes from 'prop-types';
import { compose } from 'redux';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import wireAssociationDefinitions from 'automation-ui-associations/hocs/wireAssociationDefinitions';
import SetPropertyActionMetadata from 'automation-ui-action-features/actions/set-property/SetPropertyActionMetadata';
import wireTargetProperty from 'automation-ui-action-features/actions/set-property/wireTargetProperty';
import { jsx as _jsx } from "react/jsx-runtime";
const convertPropsForWireAssociationDefinitions = WrappedComponent => props => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
  fromObjectTypeIds: [props.flowObjectTypeId]
}));
const TargetPropertyNamePropTypes = {
  actionMetadata: PropTypes.instanceOf(SetPropertyActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  // From wireTargetProperty
  targetObjectTypeId: ObjectTypeIdType,
  targetPropertyLoading: PropTypes.bool.isRequired
};
const TargetPropertyName = ({
  actionMetadata,
  targetObjectTypeId,
  targetPropertyLoading
}) => {
  const targetPropertyName = actionMetadata.getTargetPropertyName();
  if (targetPropertyLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  return targetObjectTypeId && targetPropertyName ? /*#__PURE__*/_jsx(PropertyName, {
    propertyName: targetPropertyName,
    objectTypeId: targetObjectTypeId
  }) : /*#__PURE__*/_jsx(MissingLabel, {
    type: "property"
  });
};
TargetPropertyName.propTypes = TargetPropertyNamePropTypes;
export default compose(convertPropsForWireAssociationDefinitions, wireAssociationDefinitions, wireTargetProperty)(TargetPropertyName);